import { Outlet } from 'react-router-dom';

import { SettingsHeader } from '../settings-header';
import { useGetOrganizationById } from '../../../../shared/services/get-organization-by-id';
import { useGetOrgId } from '@shared/hooks/use-get-org-id';
import { SettingsTabs } from './tabs';
import Loader from '@shared/components/reusables/loader';

export const SettingsLayout = () => {
  const orgId = useGetOrgId();
  const { data: orgData, isLoading } = useGetOrganizationById(orgId);

  if (isLoading) return <Loader />;

  return (
    <div>
      {orgData && <SettingsHeader organization={orgData} />}
      <SettingsTabs />
      <div>
        <Outlet />
      </div>
    </div>
  );
};
